<interacta-dialog
    [isOpen]="isOpen()"
    [size]="'small'"
    (closing)="closing.emit()"
>
    <h2 class="typo-t6" title>
        {{ 'APP_INFO.DIALOG_TITLE' | translate }}
    </h2>
    <div content>
        <dl class="typo-sm">
            <dt class="mb-4 typo-sm-bold">
                {{ 'APP_INFO.BACKEND_VERSION' | translate }}
            </dt>
            <dd class="mb-16">{{ backendVersion() }}</dd>
            <dt class="mb-4 typo-sm-bold">
                {{ 'APP_INFO.FRONTEND_VERSION' | translate }}
            </dt>
            <dd>{{ frontendVersion() }}</dd>

            @if (customerPlugin(); as plugin) {
                <dt class="mt-16 mb-4 typo-sm-bold">
                    {{ plugin.description }}
                </dt>
                <dd>{{ plugin.version }}</dd>
            }
        </dl>
        @if (!isProduction) {
            <interacta-toggle
                class="mt-16 block typo-sm-bold"
                [checked]="devtoolsEnabled()"
                [label]="'APP_INFO.DEVTOOLS_LABEL' | translate"
                [labelPosition]="'before'"
                (toggled)="onDevtoolsToggle($event)"
            />
        }
        <a
            class="mt-16 inline-block typo-sm text-text-primary"
            [routerLink]="['/', openSourceLicenses]"
        >
            {{ 'APP_INFO.OPEN_SOURCE_LICENSES' | translate }}
        </a>
    </div>
</interacta-dialog>

<interacta-dialog
    [isOpen]="showReloadDialog()"
    [size]="'extra-small'"
    (closing)="showReloadDialog.set(false)"
>
    <h2 class="typo-t6" title>
        {{ 'APP_INFO.DEVTOOLS_RELOAD_TITLE' | translate }}
    </h2>
    <p class="typo-sm" content>
        {{ 'APP_INFO.DEVTOOLS_RELOAD_MESSAGE' | translate }}
    </p>
    <interacta-dialog-buttons>
        <button
            interacta-dialog-button
            type="button"
            [label]="'APP_INFO.DEVTOOLS_RELOAD_LATER' | translate"
            [style]="'outlined'"
            (click)="showReloadDialog.set(false)"
        ></button>
        <button
            interacta-dialog-button
            type="button"
            [label]="'APP_INFO.DEVTOOLS_RELOAD_CONFIRM' | translate"
            [style]="'filled'"
            (click)="onReload()"
        ></button>
    </interacta-dialog-buttons>
</interacta-dialog>
